import React, { useState } from 'react';
import {
    Button,
    Modal,
    Form,
    Input,
    InputNumber,
    message,
    Divider,
    Typography,
    TimePicker,
} from "antd";
import locale from 'antd/es/date-picker/locale/es_ES';
import { PlusOutlined, PrinterOutlined, EditOutlined } from '@ant-design/icons';
import { updateData } from '../../resources';
import dayjs from 'dayjs';


const { Title } = Typography;

export default function HojaEnfermeriaEditModal({ hoja_inicial, getHojaNueva }) {

    const [form] = Form.useForm();

    // const [initialHoja, setInitialHoja] = useState(hoja_inicial)
    const [isModalOpen, setIsModalOpen] = useState(false);

    const getInitialValues = () => {
        if (!hoja_inicial) return {};
        return {
            ...hoja_inicial,
            hora_inicio: hoja_inicial.hora_inicio ? dayjs(hoja_inicial.hora_inicio) : null,
            hora_termino: hoja_inicial.hora_termino ? dayjs(hoja_inicial.hora_termino) : null,
            inicio: {
                ...hoja_inicial.inicio,
                hora: hoja_inicial.inicio?.hora ? dayjs(hoja_inicial.inicio.hora) : null
            },
            intermedio: {
                ...hoja_inicial.intermedio,
                hora: hoja_inicial.intermedio?.hora ? dayjs(hoja_inicial.intermedio.hora) : null
            },
            termino: {
                ...hoja_inicial.termino,
                hora: hoja_inicial.termino?.hora ? dayjs(hoja_inicial.termino.hora) : null
            }
        };
    };
    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleOk = async () => {
        try {
            const values = await form.validateFields();




            // setInitialHoja(values);

            console.log('Old', hoja_inicial)
            console.log('New ', values)

            updateData(`/hojas/update/${hoja_inicial._id}`, values).then(() => {
                getHojaNueva()
                setIsModalOpen(false)
            })
            // updateData(`notas/update/${id_nota}`, { hojas_enfermeria: updated }).then(() => {
            //     getNotasData()
            //     setIsModalOpen(false);
            // })

        } catch {
            message.error("Revisa los campos requeridos");
        }
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };
    return (
        <>
            <Button shape='circle' size='small' onClick={() => { showModal() }} type='primary' ghost icon={<EditOutlined />} />
            <Modal
                title="Editar hoja de enfermería"
                closable={{ 'aria-label': 'Custom Close Button' }}
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                okText="Guardar"
                cancelText="Cancelar"
                width={1100}
            >
                <Form form={form} layout="vertical" initialValues={getInitialValues()} >
                    {/* Datos generales */}
                    <div style={{ display: 'flex', gap: 8 }}>
                        <div style={{ width: '32%' }}>
                            <Form.Item label="Peso (kg)" name="peso" rules={[{ required: true, message: "Ingresa el peso" }]}>
                                <InputNumber min={0} style={{ width: "100%" }} />
                            </Form.Item>
                        </div>
                        <div style={{ width: '32%' }}>
                            <Form.Item label="IMC" name="imc">
                                <InputNumber style={{ width: "100%" }} />
                            </Form.Item>
                        </div>
                        <div style={{ width: '32%' }}>
                            <Form.Item label="Dosis" name="dosis" rules={[{ required: true, message: "Ingresa la dosis" }]}>
                                <Input />
                            </Form.Item>
                        </div>
                    </div>

                    <div style={{ display: 'flex', gap: 8 }}>
                        <div style={{ width: '32%' }}>
                            <Form.Item label="Hora de Inicio" name="hora_inicio">
                                <TimePicker format='HH:mm' placeholder='Hora de inicio' locale={locale} style={{ width: '100%' }} />
                            </Form.Item>
                        </div>
                        <div style={{ width: '32%' }}>
                            <Form.Item label="Hora de Término" name="hora_termino">
                                <TimePicker format='HH:mm' placeholder='Hora de término' locale={locale} style={{ width: '100%' }} />
                            </Form.Item>
                        </div>
                        <div style={{ width: '32%' }}>
                            <Form.Item label="Médico Tratante" name="medico_tratante">
                                <Input />
                            </Form.Item>
                        </div>
                    </div>

                    <Divider />

                    {/* Signos Vitales */}
                    <Title level={5}>Inicio</Title>
                    <div className='fila'>
                        <Form.Item name={["inicio", "hora"]} label="Hora">
                            <TimePicker format='HH:mm' placeholder='Hora' locale={locale} />
                        </Form.Item>
                        <Form.Item name={["inicio", "temperatura"]} label="Temp.">
                            <InputNumber style={{ width: "100%" }} />
                        </Form.Item>
                        <Form.Item name={["inicio", "frecuencia_cardiaca"]} label="F. Card.">
                            <Input />
                        </Form.Item>
                        <Form.Item name={["inicio", "frecuencia_respiratoria"]} label="F. Resp.">
                            <Input />
                        </Form.Item>
                        <Form.Item name={["inicio", "presion_arterial"]} label="T/A">
                            <Input />
                        </Form.Item>
                        <Form.Item name={["inicio", "saturacion_oxigeno"]} label="Sat O₂">
                            <Input />
                        </Form.Item>
                    </div>

                    <Divider />

                    <Title level={5}>Intermedio</Title>
                    <div className='fila'>
                        <Form.Item name={["intermedio", "hora"]} label="Hora">
                            <TimePicker format='HH:mm' placeholder='Hora' locale={locale} />
                        </Form.Item>
                        <Form.Item name={["intermedio", "temperatura"]} label="Temp.">
                            <InputNumber style={{ width: "100%" }} />
                        </Form.Item>
                        <Form.Item name={["intermedio", "frecuencia_cardiaca"]} label="F. Card.">
                            <Input />
                        </Form.Item>
                        <Form.Item name={["intermedio", "frecuencia_respiratoria"]} label="F. Resp.">
                            <Input />
                        </Form.Item>
                        <Form.Item name={["intermedio", "presion_arterial"]} label="T/A">
                            <Input />
                        </Form.Item>
                        <Form.Item name={["intermedio", "saturacion_oxigeno"]} label="Sat O₂">
                            <Input />
                        </Form.Item>
                    </div>

                    <Divider />

                    <Title level={5}>Término</Title>
                    <div className='fila'>
                        <Form.Item name={["termino", "hora"]} label="Hora">
                            <TimePicker format='HH:mm' placeholder='Hora' locale={locale} />
                        </Form.Item>
                        <Form.Item name={["termino", "temperatura"]} label="Temp.">
                            <InputNumber style={{ width: "100%" }} />
                        </Form.Item>
                        <Form.Item name={["termino", "frecuencia_cardiaca"]} label="F. Card.">
                            <Input />
                        </Form.Item>
                        <Form.Item name={["termino", "frecuencia_respiratoria"]} label="F. Resp.">
                            <Input />
                        </Form.Item>
                        <Form.Item name={["termino", "presion_arterial"]} label="T/A">
                            <Input />
                        </Form.Item>
                        <Form.Item name={["termino", "saturacion_oxigeno"]} label="Sat O₂">
                            <Input />
                        </Form.Item>
                    </div>

                    <Divider />

                    <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 8 }}>
                        PROCEDIMIENTOS REALIZADOS, SIGNOS Y SÍNTOMAS (OBSERVACIONES DE ENFERMERÍA)
                    </div>
                    <div style={{ display: 'flex', gap: 8 }}>
                        <div style={{ flex: 1 }}>
                            <Form.Item name="observaciones">
                                <Input.TextArea rows={5} />
                            </Form.Item>
                        </div>
                        <div style={{ width: 200 }}>
                            <Form.Item label="PHQ-9" name="phq9">
                                <Input />
                            </Form.Item>
                            <Form.Item label="GAD-7" name="gad7">
                                <Input />
                            </Form.Item>
                            <Form.Item label="COLUMBIA" name="columbia">
                                <Input />
                            </Form.Item>
                        </div>
                    </div>
                </Form>
            </Modal>
        </>
    );
};